import { gql } from '@apollo/client'
import { useCustomMutation } from 'utils/mutations'

// CAREPLAN_UPDATE

const mutation = gql`
  mutation roadmapUpdate(
    $id: ID!
    $attributes: RoadmapAttributesInput!
    $include_archived: Boolean = false
    $include_introduction: Boolean = false
    $include_request_notes: Boolean = false
    $include_health_issue: Boolean = false
    $include_first_time_visit: Boolean = false
    $include_response_threshold: Boolean = false
    $include_preferred_address: Boolean = false
    $include_preferred_distance: Boolean = false
    $include_provider_name: Boolean = false
    $include_special_needs: Boolean = false
    $include_performed_by: Boolean = false
  ) {
    roadmapUpdate(id: $id, roadmap_attributes: $attributes) {
      id
      archived @include(if: $include_archived)
      introduction @include(if: $include_introduction)
      request_notes @include(if: $include_request_notes)
      health_issue @include(if: $include_health_issue)
      first_time_visit @include(if: $include_first_time_visit)
      response_threshold @include(if: $include_response_threshold)
      roadmap_preferred_address: preferred_address
        @include(if: $include_preferred_address)
      preferred_distance @include(if: $include_preferred_distance)
      provider_name @include(if: $include_provider_name)
      performed_by @include(if: $include_performed_by)
      special_needs @include(if: $include_special_needs)
    }
  }
`

export default function useRoadmapUpdate(successMessage = 'Care Plan updated') {
  const { onMutate: onRoadmapUpdate, loading } = useCustomMutation({
    mutation,
    successMessage,
    responsePath: 'roadmapUpdate'
  })
  return { onRoadmapUpdate, loading }
}
